import { quickbooksSlice } from '../slices/quickbooksSlice';

export default quickbooksSlice.reducer;
